import { AccelerateIcon } from './Icon.Accelerate';
import { ChatIcon } from './Icon.Chat';
import { InsightsIcon } from './Icon.Insights';
import type { GetStartedItem } from './interfaces';

const defaultItems: GetStartedItem[] = [
  {
    icon: ChatIcon,
    title: (
      <>
        Ask questions in an easy<br />
        to use chat interface
      </>
    ),
  },
  {
    icon: InsightsIcon,
    size: 68,
    title: (
      <>
        Surface insights from<br />
        documents
      </>
    ),
  },
  {
    icon: AccelerateIcon,
    size: 55,
    title: (
      <>
        Accelerate work with<br />
        AI-powered first drafts
      </>
    ),
  },
];

const medicalAffairsItems: GetStartedItem[] = [
  {
    icon: ChatIcon,
    title: (
      <>
        Ask questions in an easy<br />
        to use chat interface
      </>
    ),
  },
  {
    icon: InsightsIcon,
    size: 68,
    title: (
      <>
        Surface medical insights<br />
        from all your<br />
        HCP engagements
      </>
    ),
  },
  {
    icon: AccelerateIcon,
    size: 55,
    title: (
      <>
        Accelerate medical impact tracking<br />
        with AI-powered dashboards
      </>
    ),
  },
];

export const getItems = (groupId?: number): GetStartedItem[] => {
  if (groupId === 222) {
    return medicalAffairsItems;
  }
  return defaultItems;
};

// Keep backward compatibility
export const items = defaultItems;